module.exports = __webpack_public_path__ + "static/media/mps_logo.590093a3.png";